import React, { useEffect, useState } from "react";
import { useValidationErrorHandle } from "../functions/validationErrorHandle";
function Input(props: any) {
  const validationErrorHandle = useValidationErrorHandle();
  const [number, setNumber] = useState(0);
  useEffect(() => {
    if (props?.type === "number") {
      if (props?.value < 0) {
        setNumber(0);
      } else {
        setNumber(Number(props?.value));
      }
    }
  }, [props?.value]);
  return (
    <>
      <div className={props.InputDivClass}>
        {props.label ? (
          <label className={` ${props.labelClass} text-normal `}>
            {props.label}
          </label>
        ) : (
          ""
        )}
        {props.smalllabel ? (
          <p className={props.smalllabelclass}>{props.smalllabel}</p>
        ) : (
          ""
        )}
        <div className={`relative ${props.topinputdiv} flex h-full `}>
          {props?.prefix && (
            <div className="absolute ml-2 top-1/2 transform -translate-y-1/2">
              {props?.prefix}
            </div>
          )}
          <input
            type={props.type}
            name={props.name}
            id={props.id}
            placeholder={props.placeholder}
            required={props.required}
            value={props?.type === "number" ? number : props?.value}
            min={props.min}
            max={props.max}
            maxLength={props.maxLength}
            minLength={props.minLength}
            onChange={props.onChange}
            onBlur={props?.handleBlur}
            readOnly={props.readOnly}
            step={props?.step}
            onFocus={props?.onFocus}
            autoComplete="new-password"
            className="block w-full md:px-4 sm:px-1 md:py-2 sm:py-1 mt-2 sm:text-sm md:text-md 
text-black placeholder:text-gray-400 bg-white border border-gray-border rounded-md
focus:border-sky-200 focus:ring-sky-200 focus:outline-none focus:ring focus:ring-opacity-40"
            disabled={props.disable}
          />
        </div>
        {props.error ? (
          <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
            {validationErrorHandle(props?.error)}
          </p>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

Input.defaultProps = {
  InputDivClass: "mt-10",
  labelClass: "mt-2 text-gray-700 text-sm",
};

export { Input };
